module.exports = __webpack_public_path__ + "static/media/football-signup.26fb4672.webp";